import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
import VueRouter from "vue-router";
import Es6Promise from "es6-promise";
import VueMoment from "vue-moment";
import Storage from "vue-ls";
import VueAuth from "@websanova/vue-auth";
import VueCurrencyInput from "vue-currency-input";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import VuePluralize from "vue-pluralize";
import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueFlags from "@growthbunker/vueflags";

import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import authConfig from "./auth";
import { humanize, slice, decode } from "./filters";

// store setup
import store from "./store";

// router setup
import router from "./routes/router";

// config setup
import config from "./config";

// ES6 Promise Polyfill
Es6Promise.polyfill();

// filters
Vue.filter("humanize", humanize);
Vue.filter("slice", slice);
Vue.filter("decode", decode);
Vue.filter("number", numFormat(numeral));
Vue.use(VuePluralize);

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(VueMoment);
Vue.use(Storage, {
  namespace: `${config.namespace}__`, // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local" // storage name session, local, memory
});
Vue.use(VueCurrencyInput);
Vue.use(VueFlatPickr);
Vue.use(VueFlags, {
  // Specify the path of the folder where the flags are stored.
  iconPath: "/img/flags/"
});

// configure axios
Vue.axios.defaults.baseURL = config.apiBaseUrl;

Vue.use(VueRouter);

Vue.router = router;

Vue.use(VueAuth, authConfig); // must be below 'Vue.router = router;'

Vue.axios.interceptors.request.use(config => {
  if (config.url.includes("ideal-postcodes")) {
    return config;
  }

  // standard
  config.headers["API-Key"] = config.apiKey;
  return config;
});

Vue.axios.interceptors.response.use(response => {
  // special case for getting user - remember the user data
  if (response.config.url === "/v1/users/current") {
    if (
      response.config.method === "patch" ||
      response.config.method === "get"
    ) {
      // remember the user data - email address and name
      Vue.auth.remember(JSON.stringify(response.data));
    }
  } else if (response.config.url.startsWith("/v1/accounts")) {
    // check if updating or getting the account in localstorage
    const currentAccount = store.state.account;
    if (
      currentAccount &&
      response.config.url === `/v1/accounts/${currentAccount.id}`
    ) {
      if (
        response.config.method === "patch" ||
        response.config.method === "get"
      ) {
        store.commit("SET_ACCOUNT", response.data);
      } else if (response.config.method === "delete") {
        store.commit("SET_ACCOUNT", null);
      }
    }
  }
  return response;
});

Vue.axios.interceptors.response.use(null, error => {
  if (
    error.response.status === 401 &&
    error.response.data.code === "invalid_token"
  ) {
    // clear the token - this should redirect user to login page (I think)
    Vue.auth
      .logout()
      .then(() => {
        // clear any local storage
        Vue.ls.clear();
        // clear from store
        Vue.store.commit("SET_ACCOUNT", null);
        Vue.store.commit("SET_MEMBERSHIP", null);

        Vue.router.push("/login?sessionExpired=true");
      })
      .catch(err => {
        console.error("Error after logout(): ", err);
      });
  }

  return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store
});
